<script setup lang="ts">
import { toRefs } from 'vue';
import { ViewModel, DocumentRow } from '../DocumentSearch.types';

const props = withDefaults(
	defineProps<{
		vm: ViewModel;
		documents: DocumentRow[];
		isLoaded: boolean;
		searchArchived: boolean;
	}>(),
	{
		documents: () => [],
		isLoaded: false,
		searchArchived: false,
	}
);

const { vm, documents, isLoaded, searchArchived } = toRefs(props);
</script>

<template>
	<section class="c-document-search__result">
		<div class="c-document-search__inner">
			<template v-if="documents.length === 0 && isLoaded">
				<div
					v-html="vm.CurrentBlock.NoResultXhtmlString"
					class="c-document-search__result__no-result-text"
				/>
			</template>
			<template v-else-if="documents.length > 0">
				<table aria-describedby="tabledescription">
					<thead>
						<tr>
							<th></th>
							<th scope="col" class="text-left">
								{{ vm.CurrentBlock.ColumnCode }}
							</th>
							<th scope="col" class="text-left">
								{{ vm.CurrentBlock.ColumnShortCodesCode }}
							</th>
							<th scope="col" class="text-left">
								{{ vm.CurrentBlock.ColumnLanguageCode }}
							</th>
							<th scope="col" class="text-left">
								{{ vm.CurrentBlock.ColumnSoldIn }}
							</th>
							<th scope="col" class="text-left">
								{{ vm.CurrentBlock.ColumnDetails }}
							</th>
							<th v-if="searchArchived" scope="col">
								{{ vm.CurrentBlock.ColumnArchived }}
							</th>
						</tr>
					</thead>
					<tbody>
						<tr
							v-for="result in documents"
							:key="result.code"
							data-testid="documentRow"
						>
							<td>
								<a
									:href="result.ifuResourceLink"
									target="_blank"
									class="c-document-search__result__pdf-icon"
								>
									{{ vm.CurrentBlock.PdfIconAlternateText }}
								</a>
							</td>
							<td>{{ result.code }}</td>
							<td>
								<div
									v-for="(
										catalogNumber, cnIndex
									) in result.catalogNumbers.split(/[;,]/)"
									:key="cnIndex"
								>
									{{ catalogNumber }}
								</div>
							</td>
							<td>
								<div
									v-for="(
										languageItem, liIndex
									) in result.language.split(/[;,]/)"
									:key="liIndex"
								>
									{{ languageItem }}
								</div>
							</td>
							<td>
								<div
									v-for="(
										soldInItem, siIndex
									) in result.soldIn.split(/[;,]/)"
									:key="siIndex"
								>
									{{ soldInItem }}
								</div>
							</td>
							<td>
								<div
									v-for="(
										details, dIndex
									) in result.details.split(/[;]/)"
									:key="dIndex"
								>
									{{ details }}
								</div>
							</td>
							<td v-if="searchArchived">
								<div>
									{{ result.archived || '―' }}
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</template>
		</div>
	</section>
</template>

<style lang="scss">
.c-document-search {
	&__result {
		.text-left {
			text-align: start;
		}
	}
}
</style>
